export const SET_FINAL_FORM_UNSAVED_VALUES = 'SET_FINAL_FORM_UNSAVED_VALUES';
export const REMOVE_FINAL_FORM_UNSAVED_VALUES =
    'REMOVE_FINAL_FORM_UNSAVED_VALUES';
